import { render } from "./CrossTabCount.vue?vue&type=template&id=358c2f64&scoped=true"
import script from "./CrossTabCount.vue?vue&type=script&lang=js"
export * from "./CrossTabCount.vue?vue&type=script&lang=js"

import "./CrossTabCount.vue?vue&type=style&index=0&id=358c2f64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358c2f64"]])

export default __exports__